import type { QuotaBudget } from "@t3tools/contracts";

import { i18n } from "./i18n";

export function formatQuotaRenewal(
  resetsAt: string | null,
  kind: QuotaBudget["kind"],
  locale: string,
  nowMs: number,
) {
  if (resetsAt === null) return null;
  const date = new Date(resetsAt);
  if (Number.isNaN(date.getTime())) return null;
  const t = i18n.getFixedT(locale);
  const now = new Date(nowMs);
  const tomorrow = new Date(nowMs);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const day =
    date.toDateString() === now.toDateString()
      ? t("settings/today_uw4qlo")
      : date.toDateString() === tomorrow.toDateString()
        ? t("settings/tomorrow_xyx4ee")
        : new Intl.DateTimeFormat(locale, { day: "numeric", month: "long" }).format(date);
  return kind === "monthly"
    ? day
    : t("settings/at_9rgtsd", {
        date: day,
        time: new Intl.DateTimeFormat(locale, {
          hour: "2-digit",
          minute: "2-digit",
          hourCycle: "h23",
        }).format(date),
      });
}
